<!-- <div class="spinner-container" *ngIf="loading">
        <mat-spinner></mat-spinner>
      </div> -->
<!-- [ngStyle]="{ opacity: loading ? 0 : 1 }" -->
<data-line-chart></data-line-chart>
